export default __webpack_public_path__ + "static/media/win.42321c98.wav";